import React, { useState, useContext } from 'react';
import Layout from './Layout';
import moment from 'moment';
import { Box, Button, Card, CardContent, useMediaQuery } from '@material-ui/core';
import RenderMonthHeader from './RenderMonthHeader';
import { useSelector } from 'react-redux';
import { getMinMax } from 'helper/dateRange';
import { DateRangeContext } from '../Preview/Preview.context';
import { _wm } from 'helper/wmDateUtil';
import {
	STR_TMPT_LIST,
	DC_TMPT_LIST,
	OTIF_TMPT_LIST,
	OMNI_TMPT_LIST,
	MUMD_ORDER_LIST,
	ECOM_INVENTORY
} from 'constants/constant';

function Calendar() {
	const isSmallScreen = useMediaQuery('(max-width:1100px)');
	const templateId = useSelector((state) => state.templateReducer.selectedTemplate);
	const {
		isCalMember,
		showWk,
		showWalCal,
		bussName,
		isMTSCalendar = false,
		usrSelection
	} = useContext(DateRangeContext);

	if (showWalCal) {
		moment.locale('wm');
	} else {
		moment.locale('std');
	}

	let { min, max } = getMinMax(
		templateId,
		isCalMember,
		showWk,
		bussName,
		isMTSCalendar,
		showWalCal
	);
	if (usrSelection?.start && isMTSCalendar) {
		max = _wm().getMaxForMTS(usrSelection.start, !showWk);
	}

	// Allow future date selection in MTS (Multi Time Selection) Component
	if (
		isMTSCalendar &&
		(OMNI_TMPT_LIST.includes(Number(templateId)) ||
			OTIF_TMPT_LIST.includes(Number(templateId)) ||
			STR_TMPT_LIST.includes(Number(templateId)) ||
			DC_TMPT_LIST.includes(Number(templateId)) ||
			MUMD_ORDER_LIST.includes(Number(templateId)) ||
			ECOM_INVENTORY.includes(Number(templateId)))
	) {
		// Day selection (1 year + current date)
		if (bussName === 'Date') {
			max = moment(max).clone().add(1, 'year');
		} else {
			// Week selection (1 year + current date, at end of the week)
			max = moment(max).clone().add(1, 'year').endOf('week');
		}
	}

	const minWk = moment(min);
	const maxWk = moment(max);

	const [monthIndex, setMonthIndex] = useState(moment().month());

	function handlePrevMonth() {
		setMonthIndex(monthIndex - 1);
	}

	function handleNextMonth() {
		setMonthIndex(monthIndex + 1);
	}

	return (
		<Card
			style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				flexDirection: 'column'
			}}>
			<CardContent>
				<Box
					style={{
						display: 'flex',
						justifyContent: 'space-around'
					}}>
					<Box
						style={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center'
						}}>
						<Button onClick={handlePrevMonth} id="prevMonth">
							{'<<'}
						</Button>
						<RenderMonthHeader _month={monthIndex} />
					</Box>
					<Box
						style={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center'
						}}>
						<RenderMonthHeader _month={monthIndex + 1} />
						<Button onClick={handleNextMonth} id="nextMonth">
							{'>>'}
						</Button>
					</Box>
				</Box>
				<Box style={{ display: 'flex' }}>
					<Layout
						month={isSmallScreen || isMTSCalendar ? [monthIndex] : [monthIndex, monthIndex + 1]}
						min={min.clone()}
						max={max.clone()}
						minWk={minWk.clone()}
						maxWk={maxWk.clone()}
					/>
				</Box>
			</CardContent>
		</Card>
	);
}

export default Calendar;
